import classes from './SolutionRowCell.module.css';
import * as React from 'react';
import { COLLAPSED_COLUMN_WIDTH, EXPANDED_COLUMN_WIDTH } from '../../layout';
import { Task } from '../../types';
import classNames from 'classnames';
import { pluralize } from '../../utils/stringUtils';
import { FiChevronDown } from 'react-icons/fi';
import TaskList from '../TaskList';
import { useSolutionVersionsById } from '../../state/context';

type SolutionRowCellProps = {
  isColumnExpanded: boolean;
  isRowExpanded: boolean;
  tasks: Task[];
  onClick: () => void;
};

const SolutionRowCell = ({
  isColumnExpanded,
  isRowExpanded,
  tasks,
  onClick,
}: SolutionRowCellProps) => {
  const solutionVersionsById = useSolutionVersionsById();
  const solutionVersionId = React.useMemo(() => {
    return tasks.length > 0 ? tasks[0].solutionVersionId : undefined;
  }, [tasks]);
  const solutionVersion = solutionVersionId ? solutionVersionsById[solutionVersionId] : undefined;

  return (
    <div
      className={classNames(
        classes['cell'],
        tasks.length === 0 && classes['empty'],
        isColumnExpanded && classes['column-expanded'],
        isRowExpanded && classes['row-expanded'],
      )}
      style={{
        width: isColumnExpanded
          ? EXPANDED_COLUMN_WIDTH
          : COLLAPSED_COLUMN_WIDTH,
      }}
    >
      <button className={classes['tab']} onClick={onClick}>
        {isColumnExpanded && tasks.length > 0 && (
          <div>
            <strong>{tasks.length}</strong>
            {` ${pluralize(tasks.length, 'sag', 'sager')} i alt`}
          </div>
        )}
        {isColumnExpanded && tasks.length === 0 && 'Ingen sager'}
        {isColumnExpanded === false && tasks.length === 0 && 'Ingen'}
        {isColumnExpanded === false && tasks.length > 0 && (
          <div>
            <strong>{tasks.length}</strong>
            {` i alt`}
          </div>
        )}
        {tasks.length > 0 && (
          <FiChevronDown />
        )}
      </button>
      <div
        className={classes['container']}
      >
        {isColumnExpanded && (
          <>
            {tasks.length === 0 && (
              <div className="text-xxs font-light uppercase flex text-center items-center justify-center h-full w-full pt-4">
                Ingen sager<br/> i dette sprint
              </div>
            )}
            <div className="text-xs mx-3 h-6 border-b pb-1">{solutionVersion ? `v${solutionVersion.name}` : null}</div>

            <TaskList
              tasks={tasks}
              isExpanded={true}
              includeOrganizationName={true}
            />
          </>
        )}
        {isColumnExpanded === false && (
          <>
            {tasks.length === 0 && (
              <>
                <div className={classes['placeholder']} />
                <div className={classes['placeholder']} />
                <div className={classes['placeholder']} />
                <div className={classes['placeholder']} />
                <div className={classes['placeholder']} />
                <div className={classes['placeholder']} />
              </>
            )}
            <div className="text-xs mx-3 h-6 border-b pb-1 text-center">{solutionVersion ? `v${solutionVersion.name}` : null}</div>
            <TaskList
              tasks={tasks}
              isExpanded={isColumnExpanded}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SolutionRowCell;
